'use strict';

const unitsJson = {
  AED: {
    label: "Emirati Dirham",
    symbol: "\u062F.\u0625"
  },
  ARS: {
    label: "Argentine peso",
    symbol: "Ar"
  },
  AUD: {
    label: "Australian Dollar",
    symbol: "$"
  },
  BRL: {
    label: "Brazilian Real",
    symbol: "R$"
  },
  CAD: {
    label: "Canadian Dollar",
    symbol: "$"
  },
  CHF: {
    label: "Swiss Franc",
    symbol: "Fr"
  },
  CLP: {
    label: "Chilean Peso",
    symbol: "Ch"
  },
  CNY: {
    label: "Chinese Yuan",
    symbol: "\xA5"
  },
  COP: {
    label: "Colombian peso",
    symbol: "Co"
  },
  CZK: {
    label: "Czech Koruna",
    symbol: "K\u010D"
  },
  DKK: {
    label: "Danish Krone",
    symbol: "kr"
  },
  EUR: {
    label: "Euro",
    symbol: "\u20AC"
  },
  GBP: {
    label: "British Pound",
    symbol: "\xA3"
  },
  GHS: {
    label: "Ghanaian cedi",
    symbol: "GH\u20B5"
  },
  HKD: {
    label: "Hong Kong Dollar",
    symbol: "$"
  },
  HUF: {
    label: "Hungarian Forint",
    symbol: "Ft"
  },
  IDR: {
    label: "Indonesian Rupiah",
    symbol: "Rp"
  },
  ILS: {
    label: "Israeli New Shekel",
    symbol: "\u20AA"
  },
  INR: {
    label: "Indian Rupee",
    symbol: "\u20B9"
  },
  JPY: {
    label: "Japanese Yen",
    symbol: "\xA5"
  },
  KRW: {
    label: "South Korean Won",
    symbol: "\u20A9"
  },
  MXN: {
    label: "Mexican Peso",
    symbol: "Mx"
  },
  MYR: {
    label: "Malaysian Ringgit",
    symbol: "RM"
  },
  NGN: {
    label: "Nigerian naira",
    symbol: "\u20A6"
  },
  NOK: {
    label: "Norwegian Krone",
    symbol: "kr"
  },
  NZD: {
    label: "New Zealand Dollar",
    symbol: "$"
  },
  PHP: {
    label: "Philippine Peso",
    symbol: "\u20B1"
  },
  PKR: {
    label: "Pakistani Rupee",
    symbol: "\u20A8"
  },
  PLN: {
    label: "Polish Z\u0142oty",
    symbol: "z\u0142"
  },
  RSD: {
    label: "Serbian Dinar",
    symbol: "din"
  },
  RUB: {
    label: "Russian Ruble",
    symbol: "\u20BD"
  },
  SAR: {
    label: "Saudi Riyal",
    symbol: "\u0631.\u0633"
  },
  SEK: {
    label: "Swedish Krona",
    symbol: "kr"
  },
  SGD: {
    label: "Singapore Dollar",
    symbol: "$"
  },
  THB: {
    label: "Thai Baht",
    symbol: "\u0E3F"
  },
  TRY: {
    label: "Turkish Lira",
    symbol: "\u20BA"
  },
  TWD: {
    label: "New Taiwan Dollar",
    symbol: "$"
  },
  UAH: {
    label: "Ukrainian hryvnia",
    symbol: "\u20B4"
  },
  USD: {
    label: "United States Dollar",
    symbol: "$"
  },
  ZAR: {
    label: "South African Rand",
    symbol: "R"
  }
};
module.exports = unitsJson;